import { render, staticRenderFns } from "./PromoMenuList.vue?vue&type=template&id=2e2a2a1d&scoped=true&lang=pug"
import script from "./PromoMenuList.vue?vue&type=script&lang=js"
export * from "./PromoMenuList.vue?vue&type=script&lang=js"
import style0 from "./PromoMenuList.vue?vue&type=style&index=0&id=2e2a2a1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2a2a1d",
  null
  
)

export default component.exports